export default __webpack_public_path__ + "static/media/logo-mutualofomaha.a63dc36f.png";